import type { StrapiEventListPage } from '~/composables/types/strapiEventListPage'

const STATE_KEY = 'eventListPageData'

export const useEventListPageStore = () => {
  const data = useState<StrapiEventListPage | null>(STATE_KEY, () => null)

  const set = (value: StrapiEventListPage | null) => {
    data.value = value
  }

  // Only clears if the caller still owns the current value, preventing the
  // outgoing EventListPage from wiping the incoming page's data during navigation.
  const clearIfOwner = (ownedValue: StrapiEventListPage | null) => {
    if (data.value === ownedValue) {
      data.value = null
    }
  }

  return {
    data,
    set,
    clearIfOwner,
  }
}
